/**
 * Stats Block — Frontend Script.
 *
 * Animates stat numbers using CountUp.js when the block enters the viewport.
 * Each item starts counting with a 150ms stagger.
 *
 * CountUp.js loads deferred, so it may not be available at DOMContentLoaded.
 * A polling helper waits for window.countUp.CountUp before wiring observers.
 *
 * Graceful degradation: the static value rendered in the HTML is readable
 * if JS is absent or CountUp.js fails to load.
 */

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('[data-stats-block]');

	if (!blocks.length) {
		return;
	}

	/**
	 * Poll for CountUp.js to become available, then invoke the callback.
	 * @param {Function} callback - Called once CountUp.js is ready.
	 * @param {number}   attempts - Number of attempts made so far (default 0).
	 */
	const waitForCountUp = (callback, attempts = 0) => {
		if (window.countUp && window.countUp.CountUp) {
			callback();
		} else if (attempts < 20) {
			setTimeout(() => waitForCountUp(callback, attempts + 1), 100);
		}
	};

	waitForCountUp(() => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						return;
					}

					obs.unobserve(entry.target);

					entry.target.querySelectorAll('[data-stat-item]').forEach((item, index) => {
						const el = item.querySelector('[data-stat-value]');

						if (!el) {
							return;
						}

						const endVal = parseFloat(el.dataset.endVal);
						const decimalPlaces = parseInt(el.dataset.decimalPlaces, 10) || 0;
						const prefix = el.dataset.prefix || '';
						const suffix = el.dataset.suffix || '';
						const useGrouping = el.dataset.useGrouping === '1';

						setTimeout(() => {
							const counter = new window.countUp.CountUp(el, endVal, {
								duration: 2.5,
								decimalPlaces,
								prefix,
								suffix,
								useGrouping,
								separator: ',',
							});

							if (!counter.error) {
								counter.start();
							}
						}, index * 150);
					});
				});
			},
			{ threshold: 0.2 },
		);

		blocks.forEach(block => observer.observe(block));
	});
});
